export const MODULES = [
  // MEMBER
  {
    name: 'member',
    subs: [
      { name: '*' },
      {
        name: 'lookup',
        subs: [
          { name: '*' },
          { name: 'create member' },
          { name: 'create drd member' },
        ],
      },
      { name: 'dashboard' },
      {
        name: 'transaction',
        subs: [{ name: '*' }, { name: 'download transaction' }],
      },
      {
        name: 'communication',
        subs: [
          { name: '*' },
          { name: 'view email' },
          { name: 'resend email' },
          { name: 'edit email' },
        ],
      },
      {
        name: 'communication main nz',
        subs: [
          { name: '*' },
          { name: 'view email' },
          { name: 'resend email' },
          { name: 'edit email' },
        ],
      },
      {
        name: 'voucher',
        subs: [{ name: '*' }, { name: 'update voucher status' }],
      },
      { name: 'offer' },
      {
        name: 'notes',
        subs: [
          { name: '*' },
          { name: 'view note' },
          { name: 'add note' },
          { name: 'update note' },
        ],
      },
      {
        name: 'membership',
        subs: [
          { name: '*' },
          { name: 'add membership' },
          { name: 'end membership' },
        ],
      },
      { name: 'membership subway' },
      {
        name: 'identification',
        subs: [
          { name: '*' },
          { name: 'merge identifiers' },
          { name: 'update identifier status' },
        ],
      },
      {
        name: 'identification hampsta',
        subs: [
          { name: '*' },
          { name: 'add/replace card' },
          { name: 'update identifier status' },
        ],
      },
      {
        name: 'identification generic',
        subs: [{ name: '*' }, { name: 'update identifier status' }],
      },
      { name: 'history' },
      { name: 'purchase' },
      { name: 'purchase reversal' },
      { name: 'purchase redemption' },
      { name: 'purchase redemption reversal' },
      { name: 'loyalty redemption' },
      { name: 'loyalty redemption reversal' },
      { name: 'loyalty allocation' },
      { name: 'loyalty allocation reversal' },
      { name: 'icash topup' },
      { name: 'icash topup reversal' },
      { name: 'icash redemption' },
      { name: 'icash redemption reversal' },
      { name: 'icash donation' },
      { name: 'icash donation refund' },
      { name: 'credit allocation' },
      { name: 'credit allocation refund' },
      { name: 'e-voucher redemption' },
      { name: 'send email for password reset' },
      { name: 'save to pdf' },
      { name: 'update status' },
      { name: 'update member details' },
      { name: 'update member details generic' },
      {
        name: 'bank accounts',
        subs: [
          { name: '*' },
          { name: 'add bank account' },
          { name: 'update bank account' },
        ],
      },
      {
        name: 'direct payments',
        subs: [
          { name: '*' },
          { name: 'add payment instruction' },
          { name: 'update payment instruction' },
          { name: 'skip payment instruction' },
          { name: 'cancel payment instruction' },
        ],
      },
      { name: 'orders westfield corp' },
      { name: 'orders westfield cons' },
    ],
    access: {
      status: [
        { status: 'registered', subs: [{ name: '*' }] },
        { status: 'cancelled', subs: [{ name: '*' }] },
        { status: 'suspended', subs: [{ name: '*' }] },
        { status: 'unregistered', subs: [{ name: '*' }] },
      ],
    },
  },
  // SUBSQUAD
  {
    name: 'subsquad',
    subs: [{ name: '*' }, { name: 'lookup' }, { name: 'member' }],
    access: {
      status: [],
    },
  },
  // MERCHANT
  {
    name: 'merchant',
    subs: [
      { name: '*' },
      { name: 'lookup', subs: [{ name: '*' }, { name: 'create merchant' }] },
      {
        name: 'transaction',
        subs: [{ name: '*' }, { name: 'download transaction' }],
      },
      {
        name: 'identification',
        subs: [{ name: '*' }, { name: 'update identifier status' }],
      },
      { name: 'identification create' },
      {
        name: 'device',
        subs: [{ name: '*' }, { name: 'update merchant device' }],
      },
      { name: 'device create' },
      { name: 'memberships' },
      { name: 'membership create' },
      {
        name: 'bank accounts',
        subs: [{ name: '*' }, { name: 'update bank account' }],
      },
      { name: 'bank accounts create' },
      { name: 'histories' },
      { name: 'update merchant profile' },
      { name: 'update merchant status' },
    ],
    access: {
      status: [
        { status: 'current', subs: [{ name: '*' }] },
        { status: 'terminated', subs: [] },
        { status: 'closed', subs: [{ name: 'update merchant status' }] },
      ],
    },
  },
  // CAMPAIGN
  {
    name: 'campaign',
    subs: [{ name: '*' }, { name: 'lookup' }],
    access: {
      status: [],
    },
  },
  // CAMPAIGN VOUCHER
  {
    name: 'voucher',
    subs: [
      { name: '*' },
      { name: 'lookup' },
      { name: 'create customer service voucher' },
      { name: 'create new voucher' },
      { name: 'create new marketing campaign' },
      { name: 'update marketing campaign' },
      {
        name: 'view voucher',
        subs: [{ name: '*' }, { name: 'duplicate voucher' }],
      },
      { name: 'update voucher' },
    ],
    access: {
      status: [],
    },
  },
  // REPORTS
  {
    name: 'reports',
    subs: [
      { name: '*' },
      { name: 'lookup' },
      { name: 'report 2', subs: [{ name: '*' }, { name: 'download report' }] },
      { name: 'report 13', subs: [{ name: '*' }, { name: 'download report' }] },
      {
        name: 'voucher redemption count report',
        subs: [{ name: '*' }, { name: 'download report' }],
      },
      { name: 'report 19', subs: [{ name: '*' }, { name: 'download report' }] },
    ],
    access: {
      status: [],
    },
  },
  // BULK TRANSACTIONS
  {
    name: 'bulk transactions',
    subs: [
      { name: '*' },
      { name: 'lookup' },
      { name: 'create bulk transactions' },
    ],
    access: {
      status: [],
    },
  },
  // FILES
  {
    name: 'files',
    subs: [{ name: '*' }, { name: 'files download' }],
    access: {
      status: [],
    },
  },
] as const

export type ModuleNames = (typeof MODULES)[number]['name']

export type SubModuleNames<M extends ModuleNames> = Extract<
  (typeof MODULES)[number],
  { name: M }
>['subs'][number]['name']

type SubsOf<M extends ModuleNames> = Extract<
  (typeof MODULES)[number],
  { name: M }
>['subs'][number]

export type SubSubModuleNames<M extends ModuleNames, S extends string> =
  Extract<SubsOf<M>, { name: S }> extends {
    readonly subs: readonly { name: infer N }[]
  }
    ? N
    : never
